module.exports = __webpack_public_path__ + "static/media/theRoadToNowhere.97e1a62a.jpg";